import axios from 'axios';
import store from '@/store'

import loadingHelpers from './loadingHelpers';
import notificationHelpers from './notificationHelpers';

import { loadConfig } from '../config';

let processAlerts = function (response, context) {
    if (response.Alerts != undefined && response.Alerts.length > 0) {
        let alerts = response.Alerts;
        // -- Muestro mensajes
        for (var j = 0; j < alerts.length; j++) {
            notificationHelpers.showNotification('Alerta!', alerts[j].Message, context, alerts[j].Style);
        }
    }
};


export default {
    axiosGet(url, data, context, callback, limitReachedCallback) {
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);

        loadingHelpers.showLoading(context);
        axios
            .get(fullUrl, {
                params: data,
                headers: {
                    Token: store.getters.userToken
                }
            })
            .then(function (response) {
                loadingHelpers.hideLoading(context);
                processAlerts(response.data, context);
                callback(response.data);
            })
            .catch(function (error) {
                loadingHelpers.hideLoading(context);
                // -- Si no esta autorizado
                if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                    notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                    context.$store.dispatch("logout").then(() => {
                        context.$router.push("login");
                    });
                }
                // -- Si la Cuenta tiene su Limite excedido
                else if (error.response != undefined && error.response.status != undefined && error.response.status == 409) {
                    let message = '';
                    if (context.$store.getters.identityWasVerificated == true) {
                        message = 'Estás por superar tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                    } else {
                        message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                    }

                    if (limitReachedCallback != undefined) {
                        limitReachedCallback(message);
                        return;
                    }

                    notificationHelpers.showError('Alerta!', message, context);
                }
                else 
                {
                    notificationHelpers.showError('Alerta!', 'Se ha producido un error', context);
                }
            });
        });
    },

    axiosPost(url, data, context, callback, limitReachedCallback, limitReachedWithoutRequirementCallback) {
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);

        if(store.getters.TwoStepVerification != undefined && 
           store.getters.TwoStepVerification &&
           store.getters.DoubleFactorSecurityList != undefined &&
           store.getters.DoubleFactorSecurityList.includes(url))
           { 
                context.$router.push({name:"selectSecurityMethod", params:{
                    url: url,
                    accumulationMethodTypeID: url == 'TransferenceContact/TransferToExternalAccount' 
                        ?context.$store.getters.CASH_OUT_ATTEMPTS_METHODTYPE_ID
                        :context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID, 
                    dataPost:data,
            }});
        }
        else{
            loadingHelpers.showLoading(context);
            axios
                .post(fullUrl, data, { headers: { Token: store.getters.userToken } })
                .then(function (response) {
                    
                    loadingHelpers.hideLoading(context);
                    processAlerts(response.data, context);
                    callback(response.data);
                })
                .catch(function (error) {
                    
                    loadingHelpers.hideLoading(context);
                    // -- Si no esta autorizado
                    if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                        context.$router.push('login')
                        notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                        return;
                    }
                    // -- Si la Cuenta tiene su Limite excedido
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 409) {
                        let message = '';
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Hola! Desde Resimple queremos reforzar la seguridad, por eso vamos a solicitarte más información';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }
    
                        if (limitReachedCallback != undefined) {
                            limitReachedCallback(message);
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                    // -- Si la cuenta tiene su limite excedido pero no hay requisito
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 412) {
                        let message = ''
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }

                        if (limitReachedWithoutRequirementCallback != undefined) {
                            limitReachedWithoutRequirementCallback();
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                    else 
                    {
                        notificationHelpers.showError('Alerta!', 'Se ha producido un error', context);
                    }
                });
            
        }
    }); 
    },

    axiosPostWithOutSecurityValidations(url, data, context, callback, limitReachedCallback, limitReachedWithoutRequirementCallback) {
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);
            
            loadingHelpers.showLoading(context);
            axios.post(fullUrl, data, { headers: { Token: store.getters.userToken } }).then(function (response) {
                    loadingHelpers.hideLoading(context);
                    processAlerts(response.data, context);
                    callback(response.data);
                })
                .catch(function (error) {
                    loadingHelpers.hideLoading(context);
                    // -- Si no esta autorizado
                    if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                        context.$router.push('login')
                        notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                        return;
                    }
                    // -- Si la Cuenta tiene su Limite excedido
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 409) {
                        
                        let message = '';
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Estás por superar tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }
    
                        if (limitReachedCallback != undefined) {
                            limitReachedCallback(message);
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                    // -- Si la tiene su limite excedido pero no hay requisito
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 412) {

                        let message = ''
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Estás por superar tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }

                        if (limitReachedWithoutRequirementCallback != undefined) {
                            limitReachedWithoutRequirementCallback();
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                    else 
                    {
                        notificationHelpers.showError('Alerta!', 'Se ha producido un error', context);
                    }
                });
            });
    },

    axiosPostWithoutAlerts(url, data, context, callback, limitReachedCallback, limitReachedWithoutRequirementCallback) {
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);

        loadingHelpers.showLoading(context);
        axios
            .post(fullUrl, data, { headers: { Token: store.getters.userToken } })
            .then(function (response) {
                loadingHelpers.hideLoading(context);
                callback(response.data);
            })
            .catch(function (error) {
                loadingHelpers.hideLoading(context);
                // -- Si no esta autorizado
                if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                    context.$router.push('login')
                    notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                    return;
                }
                // -- Si la Cuenta tiene su Limite excedido
                else if (error.response != undefined && error.response.status != undefined && error.response.status == 409) {
                        
                    let message = '';
                    if (context.$store.getters.identityWasVerificated == true) {
                        message = 'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                    } else {
                        message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                    }

                    if (limitReachedCallback != undefined) {
                        limitReachedCallback(message);
                        return;
                    }

                    notificationHelpers.showError('Alerta!', message, context);
                }
                // -- Si la tiene su limite excedido pero no hay requisito
                else if (error.response != undefined && error.response.status != undefined && error.response.status == 412) {

                    let message = ''
                    if (context.$store.getters.identityWasVerificated == true) {
                        message = 'Estás por superar tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                    } else {
                        message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                    }

                    if (limitReachedWithoutRequirementCallback != undefined) {
                        limitReachedWithoutRequirementCallback();
                        return;
                    }

                    notificationHelpers.showError('Alerta!', message, context);
                }
                else 
                {
                    notificationHelpers.showError('Alerta!', 'Se ha producido un error', context);
                }
            });
        });
    },

    axiosPostWithoutAlertsWithSecurityValidation(url, data, context, callback, limitReachedWithoutRequirementCallback) {
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);       
        if(store.getters.TwoStepVerification && store.getters.DoubleFactorSecurityList != undefined && store.getters.DoubleFactorSecurityList.includes(url)){
            context.$router.push({name:"selectSecurityMethod", params:{
                url: url,
                accumulationMethodTypeID: url == 'TransferenceContact/TransferToExternalAccount' 
                    ?context.$store.getters.CASH_OUT_ATTEMPTS_METHODTYPE_ID
                    :context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID, 
                dataPost:data,
            }});
         
        }else{
            loadingHelpers.showLoading(context);
            axios
                .post(fullUrl, data, { headers: { Token: store.getters.userToken } })
                .then(function (response) {
                    loadingHelpers.hideLoading(context);
                    callback(response.data);
                })
                .catch(function (error) {
                    loadingHelpers.hideLoading(context);
                    // -- Si no esta autorizado
                    if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                        context.$router.push('login')
                        notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                        return;
                    }
                    // -- Si la tiene su limite excedido pero no hay requisito
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 412) {

                        let message = ''
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Estás por superar tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }

                        if (limitReachedWithoutRequirementCallback != undefined) {
                            limitReachedWithoutRequirementCallback();
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                });
        }
    });
    },

    axiosPostWithoutAlertsForTransference(url, data, context, callback, limitReachedWithoutRequirementCallback, limitReachedCallback) {        
        loadConfig().then(config => {
        const apiUrl = config.apiUrl || '';
        //var fullUrl = `${process.env.VUE_APP_BASE_URL}`.concat(url);
        var fullUrl = `${apiUrl}`.concat(url);

        if(data.Amount >= store.getters.MinimumTransferAmount && store.getters.TwoStepVerification && store.getters.DoubleFactorSecurityList != undefined && store.getters.DoubleFactorSecurityList.includes(url)){
            context.$router.push({name:"selectSecurityMethod", params:{
                url: url,
                accumulationMethodTypeID: url == 'TransferenceContact/TransferToExternalAccount' 
                    ?context.$store.getters.CASH_OUT_ATTEMPTS_METHODTYPE_ID
                    :context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID, 
                dataPost:data,
            }});
         
        }else{
            loadingHelpers.showLoading(context);
            axios
                .post(fullUrl, data, { headers: { Token: store.getters.userToken } })
                .then(function (response) {
                    loadingHelpers.hideLoading(context);
                    callback(response.data);
                })
                .catch(function (error) {
                    loadingHelpers.hideLoading(context);
                    // -- Si no esta autorizado
                    if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
                        context.$router.push('login')
                        notificationHelpers.showError('Alerta!', 'Por favor ingrese sus credenciales', context);
                        return;
                    }
                    // -- Si la Cuenta tiene su Limite excedido
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 409) {
                        let message = '';
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Hola! Desde Resimple queremos reforzar la seguridad, por eso vamos a solicitarte más información.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }
    
                        if (limitReachedCallback != undefined) {
                            limitReachedCallback(message);
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                    // -- Si la cuenta tiene su limite excedido pero no hay requisito
                    else if (error.response != undefined && error.response.status != undefined && error.response.status == 412) {
                        let message = ''
                        if (context.$store.getters.identityWasVerificated == true) {
                            message = 'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        } else {
                            message = 'Necesitamos validar tu identidad, ingresa a configuración, validación de identidad y seguí los pasos.';
                        }

                        if (limitReachedWithoutRequirementCallback != undefined) {
                            limitReachedWithoutRequirementCallback(message);
                            return;
                        }
    
                        notificationHelpers.showError('Alerta!', message, context);
                    }
                });
        }
    });
    },

    getResponseHasErrors(response) {
        var hasError = false;

        if (response.Alerts != undefined && response.Alerts != null) {
            var index = 0;
            while (index < response.Alerts.length && !hasError) {
                var alert = response.Alerts[index];
                hasError = (alert.Style == "error");
            }
        }

        return hasError;
    }
};